import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BehaviorSubject } from 'rxjs';
import { getRecruiter } from '@src/redux/selectors/recruiter';
import { idify } from '@src/util/idify';
import { createQuestion, createOpeningDetails, createCompanyProfile } from './utils';
import { OPENING_ROUTE, QUESTION_ROUTE, COMPANY_ROUTE, PITCH_ROUTE } from './appRoutes';
import './styles.scss';

const IS_TEST_ENV = process.env.ENV === 'test';
const APP_URL = '/app/preview';

function shouldPushUpdate(nextProps, nextState, props, state) {
  return (
    nextProps.companyProfile !== props.companyProfile ||
    nextProps.opening !== props.opening ||
    nextProps.benefits !== props.benefits ||
    nextProps.data !== props.data
  );
}

@connect(state => ({
  recruiter: getRecruiter(state),
}))
export default class Preview extends PureComponent {
  static propTypes = {
    benefits: PropTypes.arrayOf(PropTypes.object.isRequired),
    companyProfile: PropTypes.object,
    opening: PropTypes.object,
    question: PropTypes.object,
    recruiter: PropTypes.object.isRequired,
    url: PropTypes.oneOf([OPENING_ROUTE, QUESTION_ROUTE, COMPANY_ROUTE, PITCH_ROUTE]).isRequired,
  };

  componentDidMount() {
    const { url, question, recruiter, opening, companyProfile, benefits } = this.props;

    let data;
    window.frameMode = 'preview';

    if (url === OPENING_ROUTE) {
      data = createOpeningDetails(opening, recruiter, companyProfile, benefits);
    } else if (url === COMPANY_ROUTE) {
      data = createCompanyProfile(companyProfile);
    } else if (url === PITCH_ROUTE) {
      data = {
        opening: opening,
        recruiter: recruiter,
      };
    } else {
      data = createQuestion(question, recruiter, companyProfile);
    }

    this.subscription = window.dataSubject$ = new BehaviorSubject(data);
    this.setPreviewLocation();
  }

  componentWillUnmount() {
    window.frameMode = undefined;
    this.subscription.unsubscribe();
    window.dataSubject$ = undefined;
  }

  componentWillUpdate(nextProps, nextState) {
    const { question, url } = this.props;

    if (url === OPENING_ROUTE && shouldPushUpdate(nextProps, nextState, this.props, this.state)) {
      window.dataSubject$.next(
        createOpeningDetails(nextProps.opening, nextProps.recruiter, nextProps.companyProfile, nextProps.benefits),
      );
    }

    if (url === COMPANY_ROUTE && shouldPushUpdate(nextProps, nextState, this.props, this.state)) {
      window.dataSubject$.next(createCompanyProfile(nextProps.companyProfile));
    }

    if (url === PITCH_ROUTE && shouldPushUpdate(nextProps, nextState, this.props, this.state)) {
      window.dataSubject$.next({
        opening: nextProps.opening,
        recruiter: nextProps.recruiter,
      });
    }

    if (url === QUESTION_ROUTE && nextProps.question !== question) {
      window.dataSubject$.next({ loading: true, question: undefined });

      setTimeout(() => {
        window.dataSubject$.next(createQuestion(nextProps.question, nextProps.recruiter, nextProps.companyProfile));
      });
    }
  }

  componentDidUpdate() {
    this.setPreviewLocation();
  }

  setPreviewLocation() {
    const { opening, companyProfile, url } = this.props;

    if (opening || companyProfile) {
      const preview = document.getElementById('details-preview');

      if (preview) {
        preview.contentWindow.location = `${APP_URL}/#${url}`;
      }
    }
  }

  render() {
    const { opening, companyProfile } = this.props;

    return (
      <div className="opening-details-preview">
        <div className="screen">
          {IS_TEST_ENV
            ? null
            : ((!!opening && !!idify(opening)) || !!companyProfile) && (
                <iframe height="740" id="details-preview" ref={'ref'} src={APP_URL} width="395" />
              )}
        </div>
      </div>
    );
  }
}
